export default __webpack_public_path__ + "static/media/download_p2.26d616e7.jpg";